import {ShiftType} from "@/graphql/generated/graphql";
import {defineStore} from "pinia";
import date from '@/helper/datetime/date'
import {kapitelDateString, kapitelMonthString} from "@/graphql/kapitelTypes";
import {fetchAutopilotStatus} from "@/helper/autopilotStatus";
import {useAuthStore} from "@/store/auth";
import {useAppState} from "@/helper/appState";
import month from "@/helper/datetime/month";

let ensureInitDone = false

interface DemandFilterSelection {
    month: kapitelMonthString,
    shiftSelection: ShiftType[]
}

export const defaultMonth = () => month.getCurrentKapitelMonth()
export const defaultShiftSelection = () => [ShiftType.Fd]

export const useDemandBrowserFilterSelectionStore = defineStore("demandBrowserFilterSelection", {
    persist: false,
    state: (): DemandFilterSelection => ({
        month: defaultMonth(),
        shiftSelection: defaultShiftSelection(),
    }),
    actions: {
        async ensureInit() {
            if (ensureInitDone) {
                return
            }
            await this.reset()
            ensureInitDone = true
        },
        async reset () {
            this.setMonth(defaultMonth())
            this.setShifts(defaultShiftSelection())

            if(useAppState().isEmployeeOrCandidate('employee')){
                const autopilotPortfolio = (await fetchAutopilotStatus(this.month))?.shiftPortfolio
                if (autopilotPortfolio) {
                    this.setShifts(autopilotPortfolio)
                }
            }
        },
        setMonth(month: kapitelMonthString) {
            this.month = month
        },

        setShifts(shiftSelection: ShiftType[]) {
            this.shiftSelection.splice(0, this.shiftSelection.length, ...shiftSelection)
        }
    }
});
